import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Box } from '@mui/system';
import { useForm } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import * as yup from 'yup';
import { FormTextField } from '../../common/form';
import { CreateContactRequest } from '../../common/PricePrgClient';
import { ProgressButton } from '../../common/ProgressButton';
import { RootState } from '../../store';
import { createContact, setShowCreateContactDialog } from './redux/contactsSlices';

const schema: yup.SchemaOf<CreateContactRequest> = yup.object().shape({
    fullName: yup.string().required().label('Full name'),
    email: yup.string().email().optional().label('Email'),
    phone: yup.string().optional().label('Phone'),
    username: yup.string().optional().label('User name')
});

const mapStateToProps = (state: RootState) => ({
    isLoading: state.contacts.ui.isLoading
});

type Props = ReturnType<typeof mapStateToProps>;
export const CreateContactDialog = ({ isLoading }: Props) => {
    const dispatch = useDispatch();

    const { handleSubmit, control } = useForm<CreateContactRequest>({
        resolver: yupResolver(schema)
    });

    const submitForm = (request: CreateContactRequest) => {
        dispatch(createContact.request(request));
    };

    const handleClose = () => {
        dispatch(setShowCreateContactDialog(false));
    };

    return (
        <Dialog open={true}>
            <DialogTitle>Create new contact</DialogTitle>
            <DialogContent sx={{ width: '300px' }}>
                <form id="mail-form" onSubmit={handleSubmit(submitForm)}>
                    <Box>
                        <FormTextField
                            label="Full name"
                            control={control}
                            name="fullName"
                            variant="standard"
                            autoComplete="off"
                            fullWidth
                        />
                    </Box>
                    <Box>
                        <FormTextField
                            fullWidth
                            name="email"
                            control={control}
                            label="Email"
                            variant="standard"
                            autoComplete="off"
                        />
                    </Box>
                    <Box>
                        <FormTextField
                            fullWidth
                            name="phone"
                            control={control}
                            label="Phone"
                            variant="standard"
                        />
                    </Box>
                    <Box>
                        <FormTextField
                            fullWidth
                            name="username"
                            control={control}
                            label="Username"
                            variant="standard"
                        />
                    </Box>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <ProgressButton color="primary" type="submit" form="mail-form" isLoading={isLoading}>
                    Send
                </ProgressButton>
            </DialogActions>
        </Dialog>
    );
};

export default connect(mapStateToProps)(CreateContactDialog);
